"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  defaultLatitude: 35.6922055,
  defaultLongitude: 139.6874118,
  defaultZoom: 15
};
exports["default"] = _default;